<template>
  <a class="action-button btn" :class="{[sizeClass]: true, ...classFromColorIndex(colorIndex,'btn-primary', 'btn-secondary')}" :href="actionUrl">
    <slot name="action-button-text" />
  </a>
</template>

<script>
export default {
  props: {
    actionUrl: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: null
    },
    colorIndex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    sizeClass() {
      switch (this.size) {
      case 'xs':
      case 'sm':
      case 'lg':
        return `btn-${this.size}`
      default:
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.action-button {
  margin-top: 5px;
  margin-bottom: 5px;
  white-space: normal;
}
</style>
